import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { type DefaultError, MutationFunction, UseMutateAsyncFunction, useMutation } from '@tanstack/react-query'
import { getApiClient } from '../api-client'
import { CreditApplicationParams } from '../type'
import { useInvalidateCreditAppDetail } from './credit-api'

interface ResendIdentityVerificationParams extends CreditApplicationParams {
  applicantType: EApplicantType
}

export const resendIdentityVerification: MutationFunction<void, ResendIdentityVerificationParams> = async ({
  creditApplicationId,
  financingProgramId,
  applicantType,
}) => {
  const apiClient = getApiClient()
  await apiClient.post(`/CreditApplication/${financingProgramId}/${creditApplicationId}/ResendIdentityVerification`, {
    applicantType,
  })
}

export function useResendIdentityVerification(
  creditApplicationId: string,
  financingProgramId: EFinancingProgram,
  applicantType: EApplicantType,
): [UseMutateAsyncFunction<void, DefaultError, void, unknown>, boolean, boolean, boolean] {
  const invalidateCreditAppDetail = useInvalidateCreditAppDetail()
  const { mutateAsync, isPending, isError, isSuccess } = useMutation<void, DefaultError, void>({
    // creditApplicationId, financingProgramId and applicantType are captured via closure; mutateAsync takes no arguments at the call site.
    mutationFn: () => resendIdentityVerification({ creditApplicationId, financingProgramId, applicantType }),
    onSuccess: () => invalidateCreditAppDetail(creditApplicationId, financingProgramId),
  })
  return [mutateAsync, isPending, isError, isSuccess]
}
